module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.user.nickname))]), _vm._v(" "), _c('td', [(_vm.user.community) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'communityDetails',
        params: {
          communitySlug: _vm.user.community.slug
        }
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.user.community.tag) + "] " + _vm._s(_vm.user.community.name))]) : _c('div', {
    staticClass: "text-muted font-italic"
  }, [_vm._v(_vm._s(_vm.$t('account.notAssociated')))])], 1), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('b-btn', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "to": {
        name: 'userDetails',
        params: {
          userUid: _vm.user.uid
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-info",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('button.details')) + "\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dc3e7b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/UserListRow.vue
// module id = 507
// module chunks = 0